module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Card_Amex-00c1ec7768ef97fbe762b886af0f83af.gif";